import React, { useState, useCallback, useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { SIDENAV_KEYS, MENU_SIDEBAR_KEYS } from '../../utils/translation-constants'
import { Formik, Form } from 'formik'
import Loading from 'custom/assets/loaders/Loading'
import InputError from '../../components/InputError/InputError'
import { DeLinkAccountSchema } from '../../schemas/others/delinkaccount'
import NeoSuccess from '../../components/FormComponents/NeoSuccess'
import NeoOTP from '../../components/FormComponents/NeoOTP'
import NeoInput from '../../components/NeoInput/NeoInput'
import NeoButton from '../../components/NeoButton/NeoButton'
import AccountsService from '../../services/accounts.service'
import { useDispatch, useSelector } from 'react-redux'
import DelinkAccountService from '../../services/delinkaccount.service'
import { setAccRefresh } from '../../actions'
import { accountsSelector } from '../../selectors'
import LayoutWithOutAccountCard from '../../layout/Layout/layout-without-card'

function DeLinkAccount() {
  const dispatch = useDispatch()
  const [stage, setStage] = useState(1)
  const { t } = useTranslation()
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const [formValues, setFormValues] = useState(null)
  const [randomKey, setRandomKey] = useState('')
  const [otp, setOtp] = useState('')
  const [accountList, setAccountList] = useState([])
  const accounts = useSelector(accountsSelector) || []

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderForm()
      case 2:
        return (
          <NeoOTP otp={otp} setOTP={setOtp} onSubmit={confirmDeLinkAccountForm} loading={loading} />
        )
      case 3:
        return <NeoSuccess message={message} linkPath='/dashboard' />
      default:
        return renderLoading()
    }
  }

  useEffect(() => {
    fetchAccounts()
  }, [])

  const fetchAccounts = useCallback(async () => {
    try {
      if (accounts.length === 0) {
        const response = await AccountsService.getAllAccounts()
        if (response.status === 200) {
          const casaAccountList = response.data['accountSummaryDetails']
          setAccountList(casaAccountList)
          setStage(1)
        }
      } else {
        if (accounts?.length > 0) {
          setAccountList(accounts)
          setStage(1)
        }
      }
    } catch (err) {
      setStage(1)
    }
  }, [])

  const confirmDeLinkAccountForm = useCallback(
    async (data = {}) => {
      try {
        setLoading(true)
        const response = await DelinkAccountService.deLinkAccountConfirm({
          srcAccount: formValues?.accountNo || data?.accountNo,
          otp: otp || '0000',
          // randomKey: randomKey,
        })
        dispatch(setAccRefresh(true))
        setLoading(false)
        setMessage(response.message)
        setStage(3)
      } catch (err) {
        setLoading(false)
      }
    },
    [otp, randomKey, formValues],
  )

  const verifyDeLinkAccountForm = useCallback(async (data, { setSubmitting }) => {
    try {
      setSubmitting(true)
      setFormValues(data)
      const response = await DelinkAccountService.deLinkAccountVerify({
        srcAccount: data.accountNo,
      })
      if (response.randomKeyEnable) {
        setRandomKey(response.randomKey)
      } else {
        setRandomKey('')
      }
      if (response.otpEnable) {
        setLoading(false)
        setStage(2)
      } else {
        setLoading(false)
        await confirmDeLinkAccountForm(data)
      }
    } catch (err) {
      setSubmitting(false)
      setLoading(false)
    }
  }, [])

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderForm() {
    if (loading) {
      return (
        <div className='justify-content-center d-flex align-items-center'>
          <Loading />
        </div>
      )
    }

    return (
      <div>
        <Formik
          initialValues={{
            accountNo: '',
          }}
          validationSchema={DeLinkAccountSchema}
          onSubmit={verifyDeLinkAccountForm}>
          {({ isSubmitting, errors, touched, handleChange }) => (
            <Form>
              <div className='form-group my-4'>
                <NeoInput
                  tabIndex='1'
                  text={t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.DELINK_ACCOUNT_NO)}
                  mode='select'
                  onChange={handleChange}
                  name='accountNo'
                  list={accountList}
                  keyValue='accountNo'
                />
                <InputError text={errors.accountNo} touched={touched.accountNo} />
              </div>

              <div className='mt-5 mb-2 px-0 col-12'>
                {isSubmitting ? (
                  renderLoading()
                ) : (
                  <NeoButton
                    tabIndex='2'
                    type='submit'
                    disabled={isSubmitting}
                    text={t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.DELINK)}
                    mode='newDesign'
                  />
                )}
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard
      breadCumKey='DE_LINK_ACCOUNT'
      keyPath={'DE_LINK_ACCOUNT'}
      showEmptySpace={true}>
      <div className='new-design-form-style'>
        <div className='heading-style'>{t(MENU_SIDEBAR_KEYS.DELINK_ACCOUNT)}</div>
        {renderSwitch()}
      </div>
    </LayoutWithOutAccountCard>
  )
}

export default DeLinkAccount
